"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
const contactDetails = [{
  id: 1,
  type: "Endereço",
  value: "Rua Cláudio Soares, 72 - Conj. 1406, Pinheiros, São Paulo - SP",
  icon: MapPin
}, {
  id: 2,
  type: "Telefone",
  value: "+55 11 96910-0007",
  icon: Phone
}, {
  id: 3,
  type: "Email",
  value: "contato@itcmais.com",
  icon: Mail
}];
const openingHours = [{
  id: 1,
  day: "Segunda - Sexta",
  hours: "08:00 - 20:00"
}, {
  id: 2,
  day: "Sábado",
  hours: "Sob Agendamento"
}, {
  id: 3,
  day: "Domingo",
  hours: "Sob Agendamento"
}];
export default function ContactInformation() {
  return <section data-section-id="223755" id="localização" className="py-32 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          
          {}
          <div className="w-full lg:w-[60%] h-[500px] lg:h-[600px] rounded-4xl border border-border shadow-xl overflow-hidden bg-muted relative flex-shrink-0">
            <iframe title="Google Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.1975!2d-46.6845!3d-23.5667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce570000000000%3A0x0!2zUnVhIGRvcyBQaW5oZWlyb3MsIDEwMjAgLSBQaW5oZWlyb3MsIF8_byBQYXVsbyAtIFNQLCAwNTQyMi0wMDA!5e0!3m2!1spt-BR!2sbr!4v1620000000000!5m2!1spt-BR!2sbr" className="absolute inset-0 w-full h-full border-0 grayscale contrast-125 opacity-90" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          </div>

          {}
          <div className="w-full lg:w-[40%] flex flex-col">
            <div className="mb-10">
              <h2 className="text-4xl font-default font-bold mb-8 tracking-tighter text-foreground">
                Localização
              </h2>
              <div className="flex flex-col gap-8">
                {contactDetails.map((item, i) => {
                const Icon = item.icon;
                return <div key={item.id} data-index={i} className="flex items-start gap-5">
                      <div className="p-3 bg-card rounded-full border border-primary/20 shadow-sm shrink-0">
                        <Icon className="w-6 h-6 text-primary" />
                      </div>
                      <div className="pt-1">
                        <h3 className="font-default font-bold text-xl mb-1 text-foreground">
                          {item.type}
                        </h3>
                        <p className="text-muted-foreground font-default leading-relaxed">
                          {item.value}
                        </p>
                      </div>
                    </div>;
              })}
              </div>
              
              <div className="mt-8">
                <Link to="https://maps.app.goo.gl/ska1rTQhxgEHqsqg6" newTab>
                  <Button className="w-full sm:w-auto rounded-full border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300" variant="outline" asChild>
                    <span>
                      <Navigation className="w-4 h-4 mr-2" />
                      Ver no Google Maps
                    </span>
                  </Button>
                </Link>
              </div>
            </div>

            <Separator className="mb-10 bg-border" />

            <div>
              <h2 className="text-2xl font-default font-bold mb-6 flex items-center gap-3 tracking-tight text-foreground">
                <Clock className="w-6 h-6 text-primary" />
                Horário de Funcionamento
              </h2>
              <ul className="flex flex-col divide-y divide-border">
                {openingHours.map((item, i) => <li key={item.id} data-index={i} className="py-4 flex justify-between items-center first:pt-0 last:pb-0">
                    <span className="text-muted-foreground font-default">{item.day}</span>
                    <span className="font-default font-semibold text-foreground">
                      {item.hours}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

        </div>
      </div>
    </section>;
}